"use client";

import { Link, PaginationBar } from "@/shared";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

type Props = {
  totalPages: number;
  currentPage: number;
};

export function WishlistPaginationBar({ totalPages, currentPage }: Props) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const getLinkHref = (page: number) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", page.toString());
    return `${pathname}?${params.toString()}`;
  };

  const navigate = (page: number) => {
    router.push(getLinkHref(page));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <PaginationBar
      totalPages={totalPages}
      currentPage={currentPage}
      onNext={(e) => {
        e.preventDefault();
        if (currentPage < totalPages) navigate(currentPage + 1);
      }}
      onPrevious={(e) => {
        e.preventDefault();
        if (currentPage > 1) navigate(currentPage - 1);
      }}
      onPageClick={(page, e) => {
        e.preventDefault();
        navigate(page);
      }}
      LinkComponent={({ page, ...props }) => (
        <Link {...props} href={getLinkHref(page)} useRouterLink />
      )}
      className="mt-6"
    />
  );
}
